import styled from "styled-components";

export const LogoContainer = styled.div<{ $margintop?: string; $marginbottom?: string; $center?: boolean }>`
  width: 100%;
  height: auto;  
  display: flex;
  justify-content: ${({ $center }) => $center ? "center" : "flex-start"};  
  margin-top: ${({ $margintop }) => $margintop || "0px"};
  margin-bottom: ${({ $marginbottom }) => $marginbottom || "0px"};
  color: #000;
  @media (max-width: 768px) {
    
  }
`;

export const LogoImg = styled.img`
  width: 120px;    
  height: 35px;
`;

